module.exports = __webpack_public_path__ + "static/media/lut-placeholder.2cfa95e0.png";